import { IConfigureLoginUseCase } from "../../../presentation/useCases/read/configure_login_use_case";
import { ConfigureLogin } from "../../models/configure_login";
import { IAuthRepository } from "../../repositories/auth_repository";

/**
 * ConfigureLoginUseCase
 */

export class ConfigureLoginUseCase implements IConfigureLoginUseCase {
  constructor(
    private readonly repository: IAuthRepository,
  ) { }

  async configureLogin(
    loginAntigo: string,
    oldPassword: string,
    loginNovo: string,
    newPassword: string,
    newPasswordConf: string,
    empresaId: number,
    newLogin: string | undefined,
  ): Promise<ConfigureLogin> {
    if (newPassword !== newPasswordConf) throw new Error('Senha e/ou confirmação de senha invalidos!');
    return await this.repository.configureLogin(
      loginAntigo,
      oldPassword,
      loginNovo,
      newPassword,
      empresaId,
      newLogin,
    );
  }
}